<template>
  <div v-testid="'トースト通知'" class="base-toast" :class="{ error }">
    <p class="message">{{ message }}</p>
    <button class="button-icon" type="button" @click="onClose">
      <BaseIcon name="close" :size="22" inheritColor />
    </button>
  </div>
</template>

<script setup lang="ts">
type Props = {
  message: string
  error: boolean
  duration: number
  onClose: () => void
}

const props = withDefaults(defineProps<Props>(), {
  message: '',
  error: false,
  duration: 3000,
  onClose: () => {},
})

const timer = ref<any>(undefined)
onMounted(() => {
  // 指定時間後に非表示 0以下の場合は非表示にしない
  if (import.meta.client && props.duration > 0) {
    timer.value = setTimeout(() => {
      props.onClose()
    }, props.duration)
  }
})
onBeforeUnmount(() => {
  if (timer.value) {
    clearTimeout(timer.value)
  }
})
</script>

<style lang="scss" scoped>
.base-toast {
  position: relative;
  padding: 17px 50px;
  background-color: $color_success;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.0572351);
  &.error {
    background-color: $color_error;
  }
  .message {
    color: #fff;
    font-size: 14px;
    line-height: 21px;
    font-weight: bold;
    text-align: center;
    white-space: pre-wrap;
  }
  .button-icon {
    width: 33px;
    height: 33px;
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    display: grid;
    place-items: center;
    color: #fff;
    @include opacity-hover;
  }
}
</style>
